export default {
  handleHTTPError: (res, errorMessage) => {
    let message = "";
    const error = new Error();
    error.response = res;
    //error.code = res.status;
    error.code = "Error";

    if (errorMessage) message = errorMessage;
    else if (res.data && res.data.message.trim().length > 0) {
      message = `${res.data.message}`;
    }

    if (res.errorName == "DecidirGatewayError") {
      if (res.status == 400) {
        message = `Decidir Gateway Error: ${res.error_type}`;
        res.validation_errors.forEach(element => {
          message = `${message} 
            ${element.code}: ${element.param}`;
        });
        message.trim();
      } else if (res.status == 402) {
        //rejected
        message = "La tarjeta fue rechazada.";
        error.id = res.status_details.error.reason.id;
        error.type = res.status_details.error.type;
        error.details =
          res.status_details.error.reason.description +
          ". " +
          res.status_details.error.reason.additional_description;
        error.ticket = res.status_details.ticket;
      }
    } else if (res.status == 444) {
      //la sesión falló, reenviar al login (444 es un codigo especial utilizado cuando falla la autenticación (no la autorización). No se usó el código 401 porque ya estaba en uso para situaciones diferentes
      this.$router.push("/users/login");
    } else if (res.status == 401) {
      message = "Usuario no autorizado.";
    } else if (res.status == 400) {
      if (message == "name must be unique")
        message = "El nombre ya existe y debe ser único.";
    }

    if (message == "") message = "Error no identificado.";

    error.message = message;
    error.status = res.status || null;
    error.statusText = res.statusText || null;
    error.response = res;
    console.log(error);
    return error;
  }
};
